import { css } from '@emotion/react';
import { Header } from '../components/Header';
import { Heading } from '../components/Heading';
import { ReactNode } from 'react';
import { PaddingStyle } from 'styles/PaddingStyle';
import { theme } from 'styles/theme';

export const ScreenCalendar = () => {
	return (
		<div>
			<Header>
				<Heading
					left={
						<div>
							<h1
								css={css`
									font-size: 24px;
									line-height: 32px;
									font-weight: normal;
									margin-bottom: 0;
								`}
							>
								Kalendář
							</h1>
						</div>
					}
				></Heading>
			</Header>

			<div
				css={css`
					display: grid;
					grid-template-columns: repeat(7, 1fr);
				`}
			>
				<CalendarHead>Pon</CalendarHead>
				<CalendarHead>Ut</CalendarHead>
				<CalendarHead>St</CalendarHead>
				<CalendarHead>Ct</CalendarHead>
				<CalendarHead>Pa</CalendarHead>
				<CalendarHead>So</CalendarHead>
				<CalendarHead>Ne</CalendarHead>
			</div>

			<div
				css={css`
					display: grid;
					grid-template-columns: repeat(7, 1fr);
				`}
			>
				<CalendarDay>30</CalendarDay>
				<CalendarDay>31</CalendarDay>
				<CalendarDay>
					01
					<div
						css={css`
							width: 100%;
							background: #ff6868;
							color: #fff;
							border-radius: 8px;
							text-align: left;
							padding-left: 8px;
							padding-right: 8px;
							margin-top: 4px;
						`}
					>
						16:00 <strong>Rest</strong> - Hiphopzije
					</div>
					<div
						css={css`
							width: 100%;
							background: #ff6868;
							color: #fff;
							border-radius: 8px;
							text-align: left;
							padding-left: 8px;
							padding-right: 8px;
							margin-top: 4px;
						`}
					>
						16:00 <strong>Rest</strong> - Hiphopzije
					</div>
				</CalendarDay>
				<CalendarDay>02</CalendarDay>
				<CalendarDay>03</CalendarDay>
				<CalendarDay>04</CalendarDay>
				<CalendarDay>05</CalendarDay>
				<CalendarDay>06</CalendarDay>
				<CalendarDay>07</CalendarDay>
				<CalendarDay>08</CalendarDay>
				<CalendarDay>09</CalendarDay>
				<CalendarDay>10</CalendarDay>
				<CalendarDay>11</CalendarDay>
				<CalendarDay>12</CalendarDay>
			</div>
		</div>
	);
};

export const CalendarHead = ({ children }: { children: ReactNode }) => {
	return (
		<div
			css={[
				PaddingStyle({ v: 8, h: 20 }),
				css`
					font-weight: 600;
					border-right: 1px solid #f0f0ff;
					border-bottom: 1px solid #f0f0ff;
					font-size: 13px;
					text-align: center;
					color: ${theme.color.text['300']};
				`,
			]}
		>
			{children}
		</div>
	);
};

export const CalendarDay = ({ children }: { children: ReactNode }) => {
	return (
		<div
			css={[
				PaddingStyle({ t: 4, h: 4, b: 12 }),
				css`
					border-right: 1px solid #f0f0ff;
					border-bottom: 1px solid #f0f0ff;
					font-size: 13px;
					font-weight: normal;
					text-align: center;
					color: ${theme.color.text['300']};
				`,
			]}
		>
			{children}
		</div>
	);
};
